import { render, staticRenderFns } from "./WidgetDailyArticle.vue?vue&type=template&id=b7d1b110&scoped=true"
import script from "./WidgetDailyArticle.vue?vue&type=script&lang=js"
export * from "./WidgetDailyArticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7d1b110",
  null
  
)

export default component.exports